// File import utilities

// Read text content from files
export const readFileAsText = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => resolve(e.target.result);
    reader.onerror = (e) => reject(e);
    reader.readAsText(file);
  });
};

// Read file as data URL (for images)
export const readFileAsDataURL = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => resolve(e.target.result);
    reader.onerror = (e) => reject(e);
    reader.readAsDataURL(file);
  });
};

// Detect language from file extension
export const detectLanguageFromFile = (filename) => {
  const ext = filename.split('.').pop().toLowerCase();
  const languageMap = {
    'js': 'javascript',
    'jsx': 'jsx',
    'ts': 'typescript',
    'tsx': 'tsx',
    'py': 'python',
    'rb': 'ruby',
    'java': 'java',
    'c': 'c',
    'cpp': 'cpp',
    'cc': 'cpp',
    'h': 'c',
    'hpp': 'cpp',
    'cs': 'csharp',
    'go': 'go',
    'rs': 'rust',
    'php': 'php',
    'swift': 'swift',
    'kt': 'kotlin',
    'scala': 'scala',
    'html': 'html',
    'htm': 'html',
    'css': 'css',
    'scss': 'scss',
    'sass': 'sass',
    'less': 'less',
    'json': 'json',
    'xml': 'xml',
    'yaml': 'yaml',
    'yml': 'yaml',
    'md': 'markdown',
    'markdown': 'markdown',
    'sql': 'sql',
    'sh': 'bash',
    'bash': 'bash',
    'zsh': 'bash',
    'ps1': 'powershell',
    'txt': 'plaintext',
    'log': 'plaintext',
    'ini': 'ini',
    'toml': 'toml',
    'dockerfile': 'dockerfile',
    'vue': 'vue',
    'svelte': 'svelte',
    'lua': 'lua',
    'r': 'r',
    'dart': 'dart',
    'graphql': 'graphql',
    'gql': 'graphql',
  };
  return languageMap[ext] || 'plaintext';
};

// Get file type info
export const getFileType = (file) => {
  const type = file.type;
  const name = file.name;
  
  if (type.startsWith('image/')) return 'image';
  if (type.startsWith('text/')) return 'text';
  if (type === 'application/json') return 'text';
  if (type === 'application/javascript') return 'text';
  if (type === 'application/xml') return 'text';
  
  // Check by extension
  const ext = name.split('.').pop().toLowerCase();
  const textExtensions = [
    'txt', 'md', 'js', 'jsx', 'ts', 'tsx', 'py', 'rb', 'java', 
    'c', 'cpp', 'h', 'cs', 'go', 'rs', 'php', 'swift', 'kt',
    'html', 'css', 'scss', 'json', 'xml', 'yaml', 'yml', 'sql',
    'sh', 'bash', 'ps1', 'ini', 'toml', 'vue', 'svelte', 'log'
  ];
  
  if (textExtensions.includes(ext)) return 'text';
  return 'unknown';
};

// Validate file size (max 5MB for text, 2MB for images)
export const validateFileSize = (file, maxSizeMB = 5) => {
  const maxSize = maxSizeMB * 1024 * 1024;
  return file.size <= maxSize;
};

// Format file size for display
export const formatFileSize = (bytes) => {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};
